import type { LocalVideoTrack } from 'livekit-client';
import { BASE_ASPECT_RATIO } from 'consts';
import {
    SharedVideoAspectRatio,
    SharedVideoFrame,
    SharedVideoRenderer,
    SharedVideoSlot,
} from '../waitingApprovalSharedView';

type WaitingApprovalLocalVideoProps = {
    track: LocalVideoTrack;
    variant: 'lottie' | 'brand';
};

export const WaitingApprovalLocalVideo = ({ track, variant }: WaitingApprovalLocalVideoProps) => (
    <SharedVideoSlot $variant={variant}>
        <SharedVideoFrame>
            <SharedVideoAspectRatio ratio={BASE_ASPECT_RATIO}>
                <SharedVideoRenderer track={track} isLocal={true} />
            </SharedVideoAspectRatio>
        </SharedVideoFrame>
    </SharedVideoSlot>
);
